exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected_form[data-v-d00699ec] {\n  width: 100%;\n}\n.container_nav_page[data-v-d00699ec] .el-pagination {\n  display: flex;\n  justify-content: end;\n}\n.footer_task[data-v-d00699ec] {\n  margin-top: 20px;\n}\n.menu_task_form[data-v-d00699ec] {\n  background-color: transparent !important;\n  display: flex;\n  justify-content: end;\n  align-content: center;\n}\n[data-v-d00699ec] .el-menu--horizontal > .el-submenu .el-submenu__title {\n  height: 36px;\n  line-height: 35px;\n  border-bottom: 0 solid transparent;\n  border-radius: 4px;\n}\n[data-v-d00699ec] .el-submenu__title i {\n  color: #fff;\n}\n", ""]);

// exports
